export enum TipoDeNotificacao {
  ResponsavelIntegracaoAtribuido = 1,
  ResponsavelIntegracaoRemovido = 2,
  ColaboradorIntegracaoIncluido = 3,
  ColaboradorIntegracaoRemovido = 4,
}
